import React from 'react'
import { useReactiveVar } from '@apollo/client'

import { NotificationTags } from 'modulesCommon/Notifications/components'
import { useFollowedTags } from 'modulesCommon/Notifications/services/useFollowedTags'
import { useCurrentUser } from 'modules/User/useCurrentUser'
import { labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'

const NotificationTagsContainer = () => {
  const { user } = useCurrentUser()
  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const spaceId = useReactiveVar(spaceIdVar)
  const { isTagFollowed, onToggle, zoneTags } = useFollowedTags({ zoneId: currentLabelId ?? user?.label_id, spaceId: spaceId ?? user?.space_id })

  return zoneTags.length ? (
    <NotificationTags tags={zoneTags} onToggle={onToggle} isTagFollowed={isTagFollowed} />
  ) : null
}

export default NotificationTagsContainer
